import { Injectable, Injector, ComponentFactoryResolver, Optional } from '@angular/core';
import { ProcessDesignerUIState } from './process-designer.uistate';
import { ProcessDesignerDataService } from '../domain/process-designer.dataservice';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ProcessClrTypeID } from '../model/process-clrtypeId';
import { BpmnProcessViewModel } from './bpmn-process.viewmodel';
import { WFFlowElementsViewModel } from './wf-flowElements.viewModel';
import { NotifyService, NotifyOptions } from '@farris/ui-notify';
import { MessagerService } from '@farris/ui-messager';
import { map, switchMap } from 'rxjs/operators';
import { FlowFormInfo } from '../domain/entities/flowform-info';
import { of, Subject, from, Observable } from 'rxjs';
import { BsModalService } from '@farris/ui-modal';
import { SaveAsEditComponent } from '../views/save-as-edit/save-as-edit.component';
import { ProcessDeUtil } from '../domain/process-de-util';
import { HttpErrorResponse } from '@angular/common/http';
import { SubProcessViewModel } from './sub-process.viewmodel';
import { AutoActivityAdapter } from './auto-activity.adapter';
import { CatchEventAdapter } from './catch-event.adapter';
import { MessageActivityAdapter } from './message-activity.adapter';
import { AuditEvent, AuditProcessDefInfo } from '../domain/entities/audit-processDef-info';
import { RTProcessInfo } from '../model/rt-process-info';
import { HttpService } from '@ecp-caf/caf-common';
import { ProcessInfo } from '../model/process-info';
import { NotifyActivityAdapter } from './notify-activity.adapter';
import { FlowFormEntity } from '../domain/entities/flowform.entity';
import { AifCreationBillActivityAdapter } from './aif-creation-bill-activity.adapter';
import { EventBusService } from '../views/shared/event-bus.service';
import { ReleaseComponent } from '../views/release-component/release-component.component';
import { BillNodeActivityAdapter } from './bill-node-activity.adapter';
import { SequenceActivityAdapter } from './sequecne-activity.adapter';
import { BpmnModel } from '@edp-pmf/bpmn-model';
import { WfLocalePipe } from '../i18n/pipe/wf-process-editor-locale.pipe';
import { LoadingService } from '@farris/ui-loading';
import { AppOptions, FrameworkService } from '@gsp-sys/rtf-common';
import { ProcessHeader } from '@gsp-wf/wf-process-model';


@Injectable()

export class ProcessDesignerViewModel {
  constructor(
    public uiState: ProcessDesignerUIState,
    private service: ProcessDesignerDataService,
    private util: ProcessDeUtil,
    private notify: NotifyService,
    private message: MessagerService,
    private process: BpmnProcessViewModel,
    private activity: WFFlowElementsViewModel,
    private subProcess: SubProcessViewModel,
    private autoActAdapter: AutoActivityAdapter,
    private catchEventAdapter: CatchEventAdapter,
    private messageActAdapter: MessageActivityAdapter,
    private notifyActAdapter: NotifyActivityAdapter,
    private creationActAdapter: AifCreationBillActivityAdapter,
    private billNodeActivityAdapter: BillNodeActivityAdapter,
    private sequenceActivityAdapter: SequenceActivityAdapter,
    private modalService: BsModalService,
    private injector: Injector,
    private resolver: ComponentFactoryResolver,
    private http: HttpService,
    private eventBus: EventBusService,
    private localePipe: WfLocalePipe,
    @Optional() private loadService: LoadingService,
    @Optional() private frameworkSvc: FrameworkService,
  ) {
    this.loadService = this.loadService || this.injector.get(LoadingService, null);
    this.frameworkSvc = this.frameworkSvc || this.injector.get(FrameworkService, null);
  }

  // 初始加载流程属性
  initProcessProperty(obj: any) {
    const pptData = obj.propertyData;
    const ffId = pptData.EntryForm;
    if (ffId) {
      pptData.EntryForm = this.uiState.flowFormInfo.flowForm;
      this.uiState.propertyConfig = this.process.setProcessConfig(obj.propertyConfig);
      this.uiState.propertyData = pptData;
    } else {
      this.uiState.propertyConfig = this.process.setProcessConfig(obj.propertyConfig);
      this.uiState.propertyData = pptData;
    }
  }
  setProperty(obj: any) {
    // 更新属性框数据与配置
    const propertyData = obj.propertyData;
    switch (propertyData.ClrTypeID) {
      case ProcessClrTypeID.process:
        this.process.setProcessProperty(obj);
        break;
      case ProcessClrTypeID.userActivity:
        this.activity.setUserActivityProperty(obj, 'userActivity');
        break;
      case ProcessClrTypeID.subProcess:
        this.subProcess.setProperty(obj);
        break;
      case ProcessClrTypeID.autoActivity:
        this.autoActAdapter.setProperty(obj);
        break;
      case ProcessClrTypeID.catchEvent:
        this.catchEventAdapter.setProperty(obj);
        break;
      case ProcessClrTypeID.operationActivity:
        this.activity.setUserActivityProperty(obj, 'autoActivity');
        break;
      case ProcessClrTypeID.messageActivity:
        this.messageActAdapter.setProperty(obj);
        break;
      case ProcessClrTypeID.notifyActivity:
        this.notifyActAdapter.setProperty(obj);
        break;
      case ProcessClrTypeID.aifCreationBillActivity:
        this.creationActAdapter.setProperty(obj);
        break;
      case ProcessClrTypeID.billNodeActivity:
        this.billNodeActivityAdapter.setProperty(obj);
        break;
      case ProcessClrTypeID.sequenceActivity:
        this.sequenceActivityAdapter.setProperty(obj);
        break;
      default:
        this.activity.setFlowElementProperty(obj);
        break;
    }
  }
  public updateSchemas(): Observable<any> {
    const $schemas = new Subject<any>();
    this.uiState.schemas = [];
    // 检查是否有精简be，如果有则覆盖原有be
    if (this.uiState.flowFormInfo.formalParameters && this.uiState.flowFormInfo.formalParameters.length > 0) {
      const schemaParams = this.uiState.flowFormInfo.formalParameters.filter(p => p.dataType === 'CDTSchema' && p.schemaMetadataId);
      const bizDefKey = this.uiState.flowFormInfo.flowForm.id;
      this.getBeMappingByBizDefKey(bizDefKey).subscribe((re) => {
        if (re && re.enable) {
          return this.service.getBusinessEntitybyId(re.newSchemaMetaDataId).subscribe(
            d => {
              let data = [d];
              if (data && data.length > 0) {
                data.forEach((d: any) => {
                  this.uiState.schemas.push(d);
                });
              }
              $schemas.next(true);
            }, err => {
              this.uiState.schemas = [];
              $schemas.next(true);
            })
        } else {
          forkJoin(schemaParams.map(para => {
            return this.service.getBusinessEntitybyId(para.schemaMetadataId);
          })).subscribe(data => {
            if (data && data.length > 0) {
              data.forEach((d: any) => {
                this.uiState.schemas.push(d);
              });
            }
            $schemas.next(true);
          }, err => {
            this.uiState.schemas = [];
            $schemas.next(true);
          });
        }
      });
    } else {
      setTimeout(() => {
        this.uiState.schemas = [];
        $schemas.next(true);
      }, 50);
    }
    return $schemas.asObservable();
  }

  public getFlowFormInfoById(formId: string): Observable<FlowFormInfo> {
    const $flowform = new Subject<FlowFormInfo>();
    if (formId) {
      forkJoin(this.service.GetFlowFormbyId(formId),
        this.service.getParametersbyFlowFormKey(formId).pipe(
          map((params: any[]) => {
            this.setFormParamCxt(params);
            return params;
          })
        ),
        this.service.getComponentsbyFlowformkey(formId),
        this.service.getExecuteFormbyFlowFormKey(formId),
        this.service.getBizActivities(formId),
        this.service.getCustomizeActions(formId)
      ).subscribe((re: any[]) => {
        const flowform = new FlowFormInfo();
        flowform.flowForm = re[0];
        flowform.formalParameters = re[1];
        flowform.bizComponents = re[2].filter(cmp => cmp.ownerType !== 'Activity');
        flowform.excuteForms = re[3];
        flowform.bizActivities = re[4];
        flowform.customizeActions = re[5];
        this.uiState.flowFormInfo = flowform;
        this.updateSchemas().subscribe((re) => {
          $flowform.next(flowform);
        });
      });
    }
    return $flowform.asObservable();
  }

  public getFormFormatsByBizCategory(): Observable<any> {
    if (this.uiState.flowFormInfo.flowForm.businessObjectId) {
      let url = `/api/runtime/wf/v1.0/formFormat/query?param=`;
      let param = `{"bizCategory":"${this.uiState.flowFormInfo.flowForm.businessObjectId}"}`;
      param = encodeURIComponent(param);
      url += param;
      return this.http.get(url);
    } else {
      return from(new Array());
    }
  }
  /**
   * 保存流程
   * @param content 流程上下文
   */
  saveProcess(content: string, processInfo: ProcessInfo, state: number): Observable<any> {
    return this.service.saveProcess(content, processInfo, state);
  }
  /**
   * 当前设计时流程是否处在审核中
   * @param procDefKey 流程定义key
   * @returns 
   */
  findReleaseProcessByProcDefKey(procDefKey: string): Observable<any> {
    return this.service.findReleaseProcessByProcDefKey(procDefKey);
  }
  /**
   * 发布流程
   * @param content 流程上下文
   */
  deployProcess(content: string): Observable<any> {
    return this.service.deployProcess(content);
  }
  /**
   * 带审核的发布流程
   * @param content 流程上下文
   */
  releaseProcess(content: string, version) {
    const process = JSON.parse(content);
    const compFactory = this.resolver.resolveComponentFactory(ReleaseComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.procName = process.DefaultProcess.Name;
    compRef.instance.procVersion = version === 1 ? 1 : version + 1;
    compRef.instance.processDefinitionKey = process.DefaultProcess.Key;
    const modalOptions = {
      title: this.localePipe.transform('app.processDesigner.releaseProcess'),
      width: 500, height: 550,
      buttons: compRef.instance.btnRef,
      showButtons: true
    };
    const dlg = this.modalService.show(compRef, modalOptions);
    compRef.instance.submit.subscribe((re: any) => {
      dlg.close();
    });
    compRef.instance.cancel.subscribe(re => {
      dlg.close();
    });
  }

  auditProcessDef(auditId: AuditEvent, success: boolean, key: string) {
    const info = new AuditProcessDefInfo();
    info.auditId = auditId;
    info.success = success;
    info.processDefKey = key;

    this.service.auditProcessDef(info);
  }

  /**
   * 保存运行时流程
   * @param content 流程上下文
   */
  saveRTProcess(content: string, procDefId: string): Observable<any> {
    return this.service.saveRTProcess(content, procDefId);
  }

  //校验表达式
  public checkExpressions (content: string, processInfo: ProcessInfo, oldBizDefKey?:string, isFromSave?): Observable<any> {
    const $schemas = new Subject<any>();
    // this.loadService.show({ container: 'body', message: '咻！咻！咻！', type: 1 });
      if(processInfo && processInfo.flowFormId && processInfo.flowFormId != '') {
        this.http.get(`/api/runtime/wf/v1.0/flowForm/parameters?key=${processInfo.flowFormId}`).subscribe(res => {
          if(res) {
            let beId;
            const cdtSchemaParameter = (res as any).find(f => f.dataType === 'CDTSchema');
            if (cdtSchemaParameter) {
              beId = cdtSchemaParameter.newSchemaMetadataId || cdtSchemaParameter.schemaMetadataId;
            }
            const schemaUrl = `/api/runtime/lcm/v1.0/bef/expression?beId=${beId}`;
            this.http.get(schemaUrl).subscribe((schema: any) => {
              if(schema) {
                this.checkExpressionsByPayload(oldBizDefKey, schema, content).subscribe(p => {
                  // this.loadService.close();
                    if(!p.pass) {
                      let MissingFields: string = "";
                      for (let i = 0; i < p.missingProperties.length; i++) {
                        MissingFields += p.missingProperties[i] + "<br>";
                      }
                      MissingFields = MissingFields.slice(0, -4); // 去掉最后一个值的顿号和换行符
                      if(!isFromSave){
                        this.uiState.msg = this.message.show('info', this.localePipe.transform('app.processDesigner.checkExpressionAfterSaveAs'), {
                          initialState: {
                            buttons: [
                              {
                                text: this.localePipe.transform('app.processDesigner.clickOk'),
                                cls: 'btn btn-primary',
                                handle: (e: any) => {
                                  this.uiState.msg.close();
                                }
                              }
                            ]
                          },
                          height: 400,
                          fitContent: false
                        }, MissingFields);
                      }else {
                        this.uiState.msg = this.message.show('info', this.localePipe.transform('app.processDesigner.checkExpressionAfterSaveAs'), {
                          initialState: {
                            buttons: [
                              {
                                text: this.localePipe.transform('app.processDesigner.clickOk'),
                                cls: 'btn btn-primary',
                                handle: (e: any) => {
                                  this.uiState.msg.close();
                                }
                              },
                              {
                                text: this.localePipe.transform('app.processDesigner.ignoreAndContinue'),
                                cls: 'btn btn-secondary',
                                handle: (e: any) => {
                                  this.uiState.isSaved = true;
                                  $schemas.next({ result: true });
                                  this.uiState.msg.close();
                                }
                              }
                            ]
                          },
                          height: 400,
                          fitContent: false
                        }, MissingFields);
                      }
                    }else {
                      this.uiState.isSaved = true;
                      $schemas.next({ result: true });
                    }
                  }
                )
              }
            });
          }
        })
      }else {
        // this.loadService.close();
        this.message.error(this.localePipe.transform('app.processDesigner.processCategoryNotFound'));
      }
      return $schemas.asObservable();
  }
  
  /**
   * 同步设计器时流程定义
   */
  syncDtProcess(content: string, rtProcessInfo: RTProcessInfo, showTip = true) {
    if (content) {
      const process = JSON.parse(content);
      if (showTip) {
        this.message.question(this.localePipe.transform('app.processDesigner.syncDt'), () => {
          this.service.syncDtProcess(content, rtProcessInfo).subscribe((data) => {
            this.notify.success({
              title: this.localePipe.transform('app.processDesigner.tips'), msg: this.localePipe.transform('app.processDesigner.syncSuccess'), timeout: 3000
            } as NotifyOptions);
            this.auditProcessDef(AuditEvent.WF_ProcessDef_SyncDT, true, process.DefaultProcess.Key);
          },
            (error: HttpErrorResponse) => {
              this.notify.error({
                title: this.localePipe.transform('app.processDesigner.tips'), msg: error.error.Message, timeout: 3000
              } as NotifyOptions);
              this.auditProcessDef(AuditEvent.WF_ProcessDef_SyncDT, false, process.DefaultProcess.Key);
            });
        });
      } else {
        this.service.syncDtProcess(content, rtProcessInfo).subscribe((data) => {
          this.notify.success({
            title: this.localePipe.transform('app.processDesigner.tips'), msg: this.localePipe.transform('app.processDesigner.syncSuccess'), timeout: 3000
          } as NotifyOptions);
          this.auditProcessDef(AuditEvent.WF_ProcessDef_SyncDT, true, process.DefaultProcess.Key);
        },
          (error: HttpErrorResponse) => {
            this.notify.error({
              title: this.localePipe.transform('app.processDesigner.tips'), msg: error.error.Message, timeout: 3000
            } as NotifyOptions);
            this.auditProcessDef(AuditEvent.WF_ProcessDef_SyncDT, false, process.DefaultProcess.Key);
          });
      }
    }
  }

  beforeCompleteStrategyChange(data: any, processInfo: RTProcessInfo): Observable<boolean> {
    const url = `/api/runtime/wf/v1.0/processInstances/runtimeActivityInstances?procDefId=${processInfo.rtProcDefId}&activityDefinitionId=${data.Id}`;
    return this.http.get(url).pipe(
      switchMap((re: any) => {
        if (re && re.length > 0) {
          this.message.info(this.localePipe.transform('app.processDesigner.beforeCompleteStrategyChange'));
          return of(false);
        } else {
          return of(true);
        }
      })
    );
  }

  public getProcessCategory(procCategoryId: string): Observable<FlowFormEntity> {
    return this.service.GetFlowFormbyId(procCategoryId);
  }


  private setFormParamCxt(params: any[]) {
    this.uiState.formalParameterContext = [];
    if (params && params.length > 0) {
      params.forEach(param => {
        if (param.dataType === 'CDTSchema') {
          const formalParameterContext = [{
            key: `schemaId_${param.code}`,
            name: `schemaId_${param.name}`,
            description: `schemaId_${param.name}`
          }, {
            key: `metadataId_${param.code}`,
            name: `metadataId_${param.name}`,
            description: `metadataId_${param.name}`
          }];
          this.uiState.formalParameterContext = this.uiState.formalParameterContext.concat(formalParameterContext);
        }
      });
    }
  }
  public copy(ResourceKeys, data) {
    this.eventBus.emit(ResourceKeys, data);
  }
  public batchSet(ResourceKeys, data) {
    this.eventBus.emit(ResourceKeys, data);
  }
  getProcDefsByKey(key: string): Observable<any> {
    if (key) {
      const url = `/api/runtime/wf/v1.0/procDefs/key?procDefKey=${key}`;
      return this.http.get(url);
    }
  }
  checkExpressionsByPayload(bizDefKey: string, schema: any, content: string): Observable<any> {
    const checkExpressionsPayload = {
      bizDefKey: bizDefKey,
      content: content,
      schema: schema
    };
    const url = `/api/runtime/wf/v1.0/dtProcDefs/checkExpressionsByPayload`;
    return this.http.post(url, JSON.stringify(checkExpressionsPayload));
  }
  
  getBeMappingByBizDefKey(bizDefKey: string): Observable<any> {
    const url = `/api/runtime/wf/v1.0/flowForm/getBeMappingByBizDefKey?bizDefKey=${bizDefKey}`;
    return this.http.get(url);
  }
}
